import { FC, ReactNode } from 'react';
import styles from './map-query-filter-sidebar.module.scss';

interface MapQueryFilterSidebarProps {
  children: ReactNode;
  isOpen: boolean;
}

export const MapQueryFilterSidebar: FC<MapQueryFilterSidebarProps> = ({
  children,
  isOpen,
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.sidebar}>
      <div className={styles.content}>{children}</div>
    </div>
  );
};
